'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogActionsStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.dialog.actions,
      paddingX = _theme$reactackle$com.paddingX,
      paddingY = _theme$reactackle$com.paddingY;
  var _theme$reactackle$com2 = theme.reactackle.components.dialog.actionItem,
      marginX = _theme$reactackle$com2.marginX,
      marginY = _theme$reactackle$com2.marginY;


  var py = typeof paddingY === 'number' && typeof marginY === 'number' ? paddingY - marginY + 'px' : 'calc(' + (0, _reactackleCore.getValueString)(paddingY) + ' - ' + (0, _reactackleCore.getValueString)(marginY) + ')';

  var px = typeof paddingX === 'number' && typeof marginX === 'number' ? paddingX - marginX + 'px' : 'calc(' + (0, _reactackleCore.getValueString)(paddingX) + ' - ' + (0, _reactackleCore.getValueString)(marginX) + ')';

  return '\n    padding: ' + py + ' ' + px + ';\n\n    > * {\n      margin: ' + (0, _reactackleCore.getValueString)(marginX) + ' ' + (0, _reactackleCore.getValueString)(marginY) + ';\n    }\n  ';
};

var DialogActionsStyled = exports.DialogActionsStyled = _styledComponents2.default.div.withConfig({
  displayName: 'DialogActionsStyled'
})(['position:relative;display:flex;justify-content:flex-end;flex-shrink:0;', ';'], baseProps);

DialogActionsStyled.propTypes = propTypes;
DialogActionsStyled.displayName = 'DialogActionsStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/DialogActions/styles/DialogActionsStyled.js
// module id = 645
// module chunks = 0